module.exports = __webpack_public_path__ + "static/media/off-day-passed-icon.bf4a16fb.png";